<template>
	<div class="col-12">
		<div class="panel_header">
			<div class="row align-items-end">
				<div v-if="block.block_title" class="col-12">
					<h2>{{ block.block_title }}</h2>
				</div>
				<div v-if="block.subtitle" class="col-12">
					<p>{{ block.subtitle }}</p>
				</div>
			</div>
		</div>

		<div v-if="okSuccessMessage">
			<div>
				<div>
					<h4 class="title title-lg mb-4">
						{{ okSuccessMessage.title }}
					</h4>
					<div v-html="okSuccessMessage.value" />
				</div>
				<div
					v-if="okSuccessMessage.is_button_enabled == 1"
					class="p-4 w-lg-50"
				>
					<a :href="okSuccessMessage.button_link">
						<b-button variant="primary">
							{{ okSuccessMessage.button_text }}
						</b-button>
					</a>
				</div>
			</div>

			<FormulateInput
				type="button"
				@click="onClickAgainSubmit"
			>
				Отправить форму повторно
			</FormulateInput>
		</div>
		<div v-else>
			<div
				v-if="mounted && autocompleted"
			>
				<FormulateForm
					v-slot="{ isLoading, hasErrors }"
					ref="formulate_SKOLKOVO100"
					v-model="formValues"
					remove-label
					@setCompanyInfo="setCompanyInfo"
				>
					<slot name="header">
						<div class="form-row mb-4">
							<div class="col-12 title">
								Основная информация
							</div>
						</div>
					</slot>
					<div class="form-row mb-4">
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="first_name"
								label="Имя *"
								placeholder="Введите значение"
								class=""
								validation-name="Имя"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="middle_name"
								label="Отчество *"
								validation="required"
								placeholder="Введите значение"
								class=""
								validation-name="Отчество"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="last_name"
								label="Фамилия *"
								placeholder="Введите значение"
								class=""
								validation="required"
								validation-name="Фото профиля"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="date"
								name="birthday"
								label="Дата рождения *"
								placeholder="Выберите значение"
								class=""
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								id="company_name"
								type="text"
								name="company_name"
								label="Место работы / Аффилиация *"
								class=""
								placeholder="Введите значение"
								validation="required"
								validation-name="Название фонда"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="job_title"
								label="Должность *"
								placeholder="Введите значение"
								class=""
								validation-name="Должность"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="email"
								label="Email *"
								class=""
								placeholder="Введите значение"
								validation="bail|required|email"
								validation-name="email"
								:validation-messages="{
									'email': 'введите корректный e-mail',
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								id="phone"
								type="text"
								name="phone"
								label="Телефон *"
								class=""
								placeholder="Введите значение"
								validation="bail|required|matches:/[0-9()-+ ]+$/"
								validation-name="Телефон"
								:validation-messages="{
									'required': 'обязательно к заполнению',
									'matches': 'введите корректный номер телефона',
								}"
							/>
						</div>
					</div>
					<div class="form-row mb-4">
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								id="photo_file"
								name="photo_file"
								type="file"
								label="Загрузите свое фото *"
								class=""
								validation-name="Загрузите свое фото"
								validation="required|^mime:image/jpeg,image/jpg,image/gif"
								:validation-messages="{
									'mime': 'Изображение должно быть формата .png/.jpg/.jpeg/.gif',
									'required': 'обязательно к заполнению',
								}"
								upload-behavior="delayed"
							/>
						</div>
					</div>
					<div class="form-row mb-4">
						<div class="col-12 title">
							О проекте
						</div>
					</div>
					<div class="form-row mb-4">
						<div class="relative col-12 col-md-12 col-lg-12 mb-3">
							<FormulateInput
								id="nomination"
								type="select"
								:options="nomination_options"
								name="nomination"
								label="Номинация *"
								class=""
								placeholder="Выберите категорию вашего проекта"
								validation="required"
								validation-name="Номинация"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-12 mb-3">
							<FormulateInput
								id="project_description"
								type="textarea"
								name="project_description"
								label="Опишите свой проект *"
								class=""
								placeholder="Расскажите о своём достижении 2024-2025 гг, проекте или кейсе, которым хотите поделиться. Что вы сделали, какие результаты достигли, почему это важно? (от 1000 до 2000 знаков с пробелами)"
								validation="required"
								validation-name="Опишите свой проект"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
					</div>
					<div class="form-row mb-4">
						<div class="relative col-12 col-md-12 col-lg-12 mb-3">
							<FormulateInput
								id="honors"
								type="textarea"
								name="honors"
								label="Награды (если есть) *"
								class=""
								placeholder="Укажите, если ваш проект получил награды. Название награды, область и год. Пример заполнения – Премия Innovate 2024, Технологии"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-12 mb-3">
							<FormulateInput
								id="public_recognition "
								type="textarea"
								name="public_recognition"
								label="Публичное признание (если есть) *"
								class=""
								placeholder="Укажите, если о вашем проекте писали в СМИ, упоминали на конференциях или в других публичных источниках. Пример заполнения: статья в Forbes, март 2024"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-12 mb-3">
							<FormulateInput
								id="links "
								type="textarea"
								name="links"
								label="Ссылки *"
								class=""
								placeholder="Приложите ссылки на статьи, сайт проекта, соцсети или другие материалы (по желанию). Пример: https://forbes.ru/article, https://project.com"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-12 mb-3">
							<FormulateInput
								id="socio_ecological_agenda"
								type="textarea"
								name="socio_ecological_agenda"
								label="Есть ли в вашем фокусе социально-экологическая повестка? Если есть, то какая? *"
								class=""
								placeholder="Укажите значение. Необязательное поле."
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
					</div>


					<div class="form-row mb-4">
						<div class="col-12 order-10">
							<agreement-input />
							<advertising-mailings-input />
							<FormulateInput
								class="col-12 px-0 small"
								type="checkbox"
								name="register100"
								validation="required"
								:validation-messages="{
									required: `${$t('agreementRequired')}`
								}"
								data-action="register100-agreement"
							>
								<template #label="{ id }">
									<label :for="id" class="ml-2">
										Отправляя форму, я даю согласие на публикацию в платформе
									</label>
								</template>
							</FormulateInput>
						</div>
					</div>

					<div class="d-flex align-items-center mt-2">
						<FormulateInput
							type="submit"
							class="mb-0"
							:disabled="isLoadingSubmit"
							@click="submit"
						>
							<b-spinner
								v-if="isLoadingSubmit"
								style="margin-right: 15px; width: 1.3em; height: 1.3em;"
							/>
							{{ isLoadingSubmit ? 'Отправляется...' : 'Отправить' }}
						</FormulateInput>
						<span v-if="isError" class="m-2 text-danger">
							Заполните поля
						</span>
						<CookieError v-if="isErrorCookie" />
					</div>
				</FormulateForm>
			</div>
		</div>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import formulateUserProfile from '~/mixins/formulateUserProfile';
import { mapActions } from 'vuex';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import moment from '@/utils/moment';

export default {
	components: {
		AgreementInput,
		AdvertisingMailingsInput,
		CookieError,
	},
	mixins: [formulateFormScenario, formulateUserProfile],
	data() {
		return {
			status: 'default',
			phoneMask: null,
			industries: [],
			fullCityInfo: null,
			values: {
				first_name: '',
				last_name: null,
				last_family_name: '',
				middle_name: '',
				birthday: '',
				email: '',
				phone: '',
				company_name: '',
				job_title: '',
				nomination: '',
				project_description : '',
				honors: '',
				public_recognition: '',
				links: '',
				socio_ecological_agenda: '',
			},
			nomination_options: [
				'Технологии и инновации',
				'Финансы и инвестиции',
				'Промышленность и производство',
				'Ритейл, фэшн и e-commerce',
				'Образование и EdTech',
				'Медиа, дизайн и креативные индустрии',
				'Здравоохранение и биотехнологии',
				'Урбанистика, строительство и девелопмент',
				'Экология и устойчивое развитие',
				'Социальное предпринимательство и НКО',
				'Международный бизнес и экспансия',
			],
			isError: false,
		};
	},
	computed: {
		isValidForm() {
			return this.$refs.formulate_SKOLKOVO100.isValid;
		},
	},

	created() {
		this.autocomplete();
		this.loadRoles();
	},
	methods: {
		getData() {
			let userData = this.formValues;

			if (!this.agreements.marketing_emails) {
				this.agreements.marketing_emails = !!this.formValues.advertisingMailingsAgreement;
			}
			if (!this.agreements.personal_data) {
				this.agreements.personal_data = !!this.formValues.personalData;
			}
			this.setAgreementFields();

			userData = {
				sklTargetAction: this.block.form_scenario_action_label,
				sklAgreeSubscribeLookup: this.formValues.advertisingMailingsAgreement ? 'да' : 'нет',
				sklBirthDate: this.formValues.birthday ? moment(this.formValues.birthday).format('DD.MM.YYYY') : '',
				...userData,
				...this.getAnalyticsData(),
			};

			return {
				user_data: userData,
				entity_name: this.fetchedData.entity_name,
				entity_id: this.fetchedData.id,
			};
		},
		...mapActions({
			loadRoles: 'profile/getRoles',
		}),
		async autocomplete() {
			try {
				const qs = `${Object.keys(this.values)
					.map((key) => `slugs[]=${encodeURIComponent(key)}`)
					.join('&')}`;

				const { data: values, visibility } = await this.$api.getUserProfileFields(qs);
				this.visibility = visibility;
				Object.keys(values).forEach((key) => {
					if (values[key]) {
						if (key === 'extended_abstract') {
							this.formValues.extended_abstract = [{
								url: values[key],
								name: 'Доклад-Аннотация',
							}];
						} else {
							this.formValues[key] = values[key];
						}
					}
				});
			} catch (error) {
				console.log(error);
			}
		},
		async submit() {
			this.isError = false;
			if (this.isValidForm) {
				this.isLoadingSubmit = true;
				this.errorMessage = null;

				if (!this.isCookiesAccepted) {
					this.showCookieError();
					this.isErrorCookie = true;
					this.isLoadingSubmit = false;

					return;
				}
				const data = this.getData();

				this.isErrorCookie = false;

				window.dataLayer = window.dataLayer || [];
				// eslint-disable-next-line no-undef
				dataLayer.push({
					event: 'form_send',
					form_data: data,
				});

				const formData = new FormData();

				this.createFormData(formData, data);

				await this.$api
					.submitFormulateForm(
						this.block.scenario_id,
						formData,
					)
					.then((response) => {
						window.location = response.url;
					})
					.catch((error) => {
						this.isLoadingSubmit = false;
						if (error.response.status === 422) {
							this.errorMessage = 'Вы уже подали заявку ранее. В ближайшее время с Вами свяжется консультант';
						}
					});
			} else {
				this.isError = true;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.text-decoration-none {
	cursor: pointer;
}

.formulate-form, .custom-control-label, .formulate-input, .formulate-input .formulate-input-label {
	font-family: $font-family-base !important;
	font-weight: 500 !important;
}

.field-required {
	&.formulate-input[data-classification='text'] input {
		border: 1px solid red !important;
	}
}

.custom-switch {
	line-height: 1.8;
}

.alert-primary {
	color: $white;
	background-color: $link-color;
	border-color: $link-color;
}

.close_link {
	display: flex;
	align-items: center;
	justify-content: space-between;
	line-height: 1;
	padding: 0;
	border: 0;
	background: transparent;
	outline: 0;
	cursor: pointer;

	&::after {
		position: relative;
		content: "\e915";
		font-family: "sk_icons";
		line-height: 1;
		font-size: .8rem;
		margin-left: 0.5rem;
		padding: 4px;
		cursor: pointer;
	}
}

span {
	margin: 0;
	line-height: 1.3;

	&.price-muted {
		font-size: 1.5rem;
		text-decoration: line-through;
		color: $border-color;
	}
}

.end-price {
	background: #FFFFFF;

	.amount-wrapper {
		border-right: 1px dashed $border-color;
		height: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-right: 30px;
	}
}

.amount {
	font-weight: bold;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	@include media-breakpoint-up(sm) {
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
	}
}

.total-price {
	padding: 1rem;
	border: 1px solid $border-color;
	display: flex;
	background-color: #455FED;
	color: #FFFFFF;
	flex-direction: column;
	justify-content: space-between;
	@include media-breakpoint-up(sm) {
		padding: 2rem 1.5rem;
	}

	.description-small {
		font-weight: 400;
		line-height: 20px;
		color: #9BA9F7;

	}

	.education {
		border-top: 1px solid #FFFFFF;
	}

	input {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $border-color;
		width: 100%;
		outline-style: none;

		&::placeholder {
			color: $border-color;
		}
	}

	.input_under_span {
		font-size: 0.8rem;
		line-height: 1.2;
		font-weight: normal;
	}

	.btn-outline-secondary {
		color: $border-color;
		border-color: $border-color;

		&:hover {
			color: $white;
			border-color: $link-hover-color;
			background-color: $link-hover-color;
		}
	}

	.sum {
		margin: 2rem 0;
	}
}

// .custom-control-input:checked ~ .custom-control-label::before {
// 	color: #fff;
// 	border: #FFFFFF;
// }

.discount {
	.formulate-input-element {
		&.formulate-input-element--text {
			input {
				border: none !important;
				border-bottom: 1px solid black !important;
				padding-left: 0px !important;
				padding-bottom: 1rem !important;

				&::placeholder {
					color: black !important;
				}
			}
		}

		&.formulate-input-element--submit {
			button {
				font-weight: 400 !important;
			}
		}

	}
}

.relative {
	position: relative;
}

.user-profile-dadata-input-label {
	font-weight: 500;
	line-height: 1.2;
	margin-bottom: 0.5rem;
}

.custom-padding {
	padding-top: 0rem !important;

	@include media-breakpoint-up(lg) {
		padding-top: 1.2rem !important;
	}
}

</style>
<style lang="scss">
.user-profile-dadata-input {
	& .vs__input {
		border-radius: 0 !important;
		border: 1px solid #949ABA !important;
		font-size: 1rem !important;
		padding: 1.3rem 1rem 1.3rem 1rem !important;
		line-height: 1.5rem !important;
		height: calc(1.5em + 0.75rem + 2px);
		font-family: "Raleway", sans-serif;
		font-weight: 500;

		&::placeholder {
			font-weight: 300;
			color: #959BBA;
		}
	}
}

.user-profile-industries-select {
	border-radius: 0 !important;
	border: 1px solid #949ABA !important;
	font-size: 1rem !important;
	padding-left: 1rem;
	line-height: 1.5rem !important;
	height: 2.7rem;
	font-family: "Raleway", sans-serif;
	font-weight: 500;
	background-position-x: 96%;

	&::placeholder {
		font-weight: 300;
		color: #959BBA;
	}
}
</style>
